import SEO from '../../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import WhatIsInstant from './components/WhatIsInstant';
import CardRanking from './components/CardRanking';
import Benefits from './components/Benefits';
import Cautions from './components/Cautions';
import HowToChoose from './components/HowToChoose';
import Conclusion from './components/Conclusion';
import Footer from './components/Footer';
import Breadcrumb from '../../../components/feature/Breadcrumb';

export default function InstantIssuePage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Article',
        headline: '即日発行できるクレジットカード完全ガイド｜最短10秒発行の方法',
        description: '即日発行可能なクレジットカードを徹底比較。最短10秒で発行できる三井住友カード（NL）をはじめ、即日受取可能なカードの選び方、申込方法、注意点を詳しく解説します。',
        author: {
          '@type': 'Organization',
          name: 'クレジットカード比較'
        },
        datePublished: '2026-01-01',
        dateModified: new Date().toISOString().split('T')[0],
        image: 'https://public.readdy.ai/ai/img_res/a8d3d0265212555839916bc955d015c3.jpg'
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'ホーム',
            item: 'https://yourdomain.com/'
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '記事一覧',
            item: 'https://yourdomain.com/#articles'
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: '即日発行クレジットカード',
            item: 'https://yourdomain.com/articles/instant-issue'
          }
        ]
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="即日発行できるクレジットカード完全ガイド｜最短10秒発行の方法"
        description="即日発行可能なクレジットカードを徹底比較。最短10秒で発行できる三井住友カード（NL）をはじめ、即日受取可能なカードの選び方、申込方法、注意点を詳しく解説します。"
        keywords="クレジットカード,即日発行,最短10秒,三井住友カード,即日受取,デジタルカード,すぐ使える"
        canonicalUrl="https://yourdomain.com/articles/instant-issue"
        ogImage="https://readdy.ai/api/search-image?query=modern%20credit%20card%20with%20instant%20digital%20issuance%20technology%20holographic%20elements%20on%20clean%20white%20background%20professional%20product%20photography%20high%20quality%20detailed%20sharp%20focus&width=1200&height=630&seq=instant-issue-og&orientation=landscape"
        structuredData={structuredData}
      />
      <Header />
      <Breadcrumb items={[
        { label: 'ホーム', path: '/' },
        { label: '記事一覧', path: '/#articles' },
        { label: '即日発行クレジットカード' }
      ]} />
      <Hero />
      <WhatIsInstant />
      <CardRanking />
      <Benefits />
      <Cautions />
      <HowToChoose />
      <Conclusion />
      <Footer />
    </div>
  );
}
